import { createQueryKeys } from "@lukemorales/query-key-factory";

import { registerAndBook } from "~/api/staffScheduling";
import {
  getAppointmentSlotsByFirstAvailable,
  getAppointmentSlotsByProvider,
  getAppointmentTypes,
  getProviders,
  scheduleVisit,
} from "./api";

export const queries = createQueryKeys("scheduling", {
  appointmentSlotsByProvider: (params: {
    stateId?: number | null;
    appointmentType: string;
    startDate: string;
    dateRange: string;
    providerId?: number;
    insuranceId?: number | null;
    isAdmin?: boolean;
  }) => {
    const { isAdmin, ...apiParams } = params;
    return {
      queryKey: ["appointment-slots", params],
      queryFn: () => getAppointmentSlotsByProvider(apiParams, isAdmin),
    };
  },
  appointmentSlotsByFirstAvailable: (params: {
    stateId?: number | null;
    appointmentType: string;
    startDate: string;
    dateRange: string;
    insuranceId?: number | null;
  }) => {
    return {
      queryKey: ["appointment-slots", params],
      queryFn: () => getAppointmentSlotsByFirstAvailable(params),
    };
  },
  providers: (
    stateId?: number | null,
    insuranceId?: number | null,
    appointmentType?: string,
  ) => {
    return {
      queryKey: ["providers"],
      queryFn: () => getProviders(stateId, insuranceId, appointmentType),
    };
  },
  appointmentTypes: () => {
    return {
      queryKey: ["appointment-types"],
      queryFn: () => getAppointmentTypes(),
    };
  },
});

export const mutations = {
  scheduleVisit,
  registerAndBook,
};
